import axios from "axios";

export default {
    namespaced: true,

    state: {
        editFolderModal: false,
        editContentModal: false,

        loadTableParams: {},
        routes: {},

        items: [],
        selectedItem: {},

        itemToRemove: {},
        removeContent: null,

        itemToUpdate: {},

        searchValue: '',

        selectedRows: [],

        removeContentModal: false
    },

    mutations: {
        showEditFolderModal(state) {
            state.editFolderModal = true;
        },
        closeEditFolderModal(state) {
            state.editFolderModal = false;
        },

        showEditContentModal(state) {
            state.editContentModal = true;
        },
        closeEditContentModal(state) {
            state.editContentModal = false;
        },

        showRemoveContentModal(state) {
            state.removeContentModal = true;
        },
        hideRemoveContentModal(state) {
            state.removeContentModal = false;
        },

        getLoadTableParams(state, params) {
            state.loadTableParams = params;
        },

        getSearchValue(state, searchValue) {
            state.searchValue = searchValue;
        },

        getRoutes(state, routes) {
            state.routes = routes;
        },

        setItems(state, items) {
            state.items = items;
        },

        selectItem(state, item) {
            state.selectedItem = item;
        },

        deselectItem(state) {
            state.selectedItem = {};
        },

        setItemToRemove(state, { item, removeContent }) {
            state.itemToRemove = item;
            state.removeContent = removeContent;
        },

        setItemToUpdate(state, item) {
            state.itemToUpdate = item;

            if (state.itemToUpdate.type == 2) {
                state.editFolderModal = true
            } else if (state.itemToUpdate.type == 1) {
                state.editContentModal = true;
            }
        },

        updateSelectedRows(state, data) {
            if (data.event.target.checked) {
                if (!state.selectedRows.find(row => row.id === data.selectedRow.id)) {
                    state.selectedRows.push(data.selectedRow);
                }
            } else {
                state.selectedRows = state.selectedRows.filter(item => item.id !== data.selectedRow.id);
            }
        },

        clearSelectedRows(state) {
            state.selectedRows = [];
        }
    },

    actions: {
        // Мультиудаление контента
        async deleteItem({ state, dispatch, commit }) {
            if (!state.selectedRows.length) {
                console.warn("Нет элементов для удаления");
                return;
            }

            const contentToRemove = [];
            const dirsToRemove = [];

            state.selectedRows.forEach(row => {
                if (row.type === 2) {
                    dirsToRemove.push(row.id);
                } else {
                    contentToRemove.push(row.id);
                }
            });

            if (contentToRemove.length) {
                await dispatch("deleteContentBatch", contentToRemove);
            }

            if (dirsToRemove.length) {
                await Promise.all(
                    dirsToRemove.map(dir =>
                        axios.delete(state.routes.deleteFolderRoute, {
                            params: {
                                group_id: dir,
                                del_content: true
                            }
                        })
                    )
                );
            }

            await dispatch("loadItems");
            commit("clearSelectedRows");
        },

        async loadItems({ state, commit }) {
            commit("setItems", []);
            const args = state.loadTableParams;

            await axios.get(state.loadTableParams.route, {
                params: {
                    page: args.page,
                    limit: args.limit,
                    search: state.searchValue,
                    params: args.filter
                }
            }).then(response => {
                if (response) commit("setItems", response.data.items);
                else console.log('Не удалось получить список контента');
            });
        },

        async deleteFolder({ state, commit, dispatch }) {
            await axios.delete(state.routes.deleteFolderRoute, {
                params: {
                    group_id: state.itemToRemove.id,
                    del_content: state.removeContent
                }
            }).then(response => {
                if (response) {
                    commit("deselectItem");
                    dispatch("loadItems");
                }
                else console.log('Не удалось удалить папку');
            });
        },

        async deleteFolders({ state, dispatch }, data) {
            await axios.delete(state.routes.deleteFolderRoute, {
                params: {
                    group_ids: data.folderIds,
                    del_content: true // Удалить папки вместе с содержимым
                }
            }).then(response => {
                if (response) {
                    dispatch("loadItems"); // Обновить таблицу
                }
                else console.log('Не удалось удалить папки');
            });
        },

        async deleteContent({ state, commit, dispatch }) {
            await axios.delete(state.routes.deleteContentRoute, {
                params: {
                    id: state.itemToRemove.id
                }
            }).then(response => {
                if (response) {
                    commit("deselectItem");
                    dispatch("loadItems");
                }
                else console.log('Не удалось удалить контент');
            });
        },

        async deleteContentBatch({ state, commit, dispatch }, contentToRemove) {
            await axios.post(state.routes.deleteContentBatch,
                    { ids: contentToRemove })
                .then(response => {
                    if (response) {
                        commit("deselectItem");
                        dispatch("loadItems"); // Обновить таблицу
                    }
                    else console.log('Не удалось удалить контент');
                }
            );
        },

        async editFolder({ state, commit, dispatch }) {
            await axios.post(state.routes.editFolderRoute, {
                group_id: state.itemToUpdate.id,
                name: state.itemToUpdate.title
            }).then(response => {
                if (response) {
                    commit("closeEditFolderModal");
                    dispatch("loadItems");
                }
                else console.log('Не удалось изменить контент');
            });
        },

        async editContent({ state, commit, dispatch }) {
            let formData = new FormData();
            formData.append('name', state.itemToUpdate.name);
            formData.append('duration', state.itemToUpdate.duration);
            formData.append('is_statistics_enabled', state.itemToUpdate.is_statistics_enabled);
            formData.append('id', state.itemToUpdate.id.toString());

            await axios.post(state.routes.editContentRoute, formData)
                .then(response => {
                    if (response) {
                        commit("closeEditContentModal");
                        dispatch("loadItems");
                    }
                    else console.log('Не удалось изменить контент');
                });
        }
    },

    getters: {

    }
};
